import { render, staticRenderFns } from "./rolesSelector.vue?vue&type=template&id=3ccfe860&scoped=true&"
import script from "./rolesSelector.ts?vue&type=script&lang=ts&"
export * from "./rolesSelector.ts?vue&type=script&lang=ts&"
import style0 from "./rolesSelector.scss?vue&type=style&index=0&id=3ccfe860&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccfe860",
  null
  
)

export default component.exports